import { render, staticRenderFns } from "./productImport.vue?vue&type=template&id=58e0d0e8&scoped=true&"
import script from "./productImport.vue?vue&type=script&lang=js&"
export * from "./productImport.vue?vue&type=script&lang=js&"
import style0 from "./productImport.vue?vue&type=style&index=0&id=58e0d0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0d0e8",
  null
  
)

export default component.exports